import { getItem, removeItem, setItem } from '@rover/utilities/localStorage.client';

import { createSSPCouponCache } from './sspCouponCache.common';

export const STORAGE_KEY = 'roverSSPCoupon';

export type { StorageAdapter } from './sspCouponCache.common';
export { SSP_COUPON_TTL_MS } from './sspCouponCache.common';

export const { cacheSSPCoupon, getCachedSSPCoupon, clearSSPCoupon } = createSSPCouponCache({
  getItem: () => getItem(STORAGE_KEY),
  setItem: (value) => setItem(STORAGE_KEY, value),
  removeItem: () => removeItem(STORAGE_KEY),
});
